import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-upload-file-dialog',
  templateUrl: './upload-file-dialog.component.html',
  styleUrls: ['./upload-file-dialog.component.scss']
})
export class UploadFileDialogComponent  {

 
  @ViewChild('fileInput', { static: true }) fileInputRef: ElementRef;

  constructor(
    public dialogRef: NbDialogRef<UploadFileDialogComponent>) { }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onSaveClick(): void {
    if (this.fileInputRef.nativeElement && this.fileInputRef.nativeElement.files.length) {
      this.dialogRef.close(this.fileInputRef.nativeElement.files);
    } else {
      alert('Aucun fichier selectionné');
    }
  }

  uploadFile(files: any) {
    this.fileInputRef.nativeElement.files = files;
  }

  onInputChange(event: any) {
    this.fileInputRef.nativeElement.files = event.target.files;
  }

}
